import { useEffect, useState, useMemo } from "react";
import Form from "react-bootstrap/Form";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import Layout from "../../layouts/default";
import Classes from "./style.module.css";
import { Row, Col, Button } from "react-bootstrap";
import ProgressBar from "../../components/Campaigns/ProgressBar";
import CampaignFooter from "../../components/Campaigns/CampaignFooter";
import { useDispatch, useSelector } from "react-redux";
import AsyncSelect from "react-select/async";

import * as Yup from "yup";

import {
  updateCampaign,
  loadCampaign,
} from "../../store/slices/campaigns/createCampaign";
import { getAudiences } from "../../store/slices/audiences/audiences";
import AudienceSelector from "../../components/Audience/AudienceSelector";
import { loadCampaignRecurrence } from "../../store/slices/campaigns/createCampaignRecurrence";
import { audienceActions } from "../../store/slices/audiences/audience";
import { getCampaignErrorCount } from "../../store/slices/campaigns/campaignErrors";
import { fetchAllVendors } from "../../store/slices/vendors/vendors";
import IvrExcludeAudience from "./IvrExcludeAudience";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

const SetCampaignAudience = () => {
  const [isAudienceValid, setIsNameValid] = useState(true);
  const [dataSourceType, setDataSourceType] = useState({
    label: "Audience search by",
    value: "",
  });
  const [dataSourceTypeError, setDataSourceTypeError] = useState(null);
  const [platformSelectError, setPlatFormSelectError] = useState(null);
  const { campaign, updateCampData } = useSelector(
    (state) => state.createCampaignSlice
  );

  console.log("skdfksskdsdak :", campaign)
  const { audiences } = useSelector((state) => state.audiencesSlice);
  const [selectedAudience, setSelectedAudience] = useState({
    label: "Select Audience",
    value: "",
  });
  const { campaignRecurrence } = useSelector(
    (state) => state.createCampaignRecurrenceSlice
  );
  const [checkAudience, setCheckAudience] = useState(0);
  const [selected, setSelected] = useState("yes");
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const [platform, setPlatform] = useState({
    label: "Select a Platform",
    value: "",
  });
  const { vendors } = useSelector((store) => store.vendorReducer);
  console.log("vendersssss : ", vendors);
  const [showIvrExcludeAudienceModal, setShowIvrExcludeAudienceModal] = useState(false);
  let campaignSchema = Yup.object().shape({
    id: Yup.number().required("Name is required."),
    audience: Yup.number().required("Audience is required."),
    // dataSourceType: Yup.string().required("Audience search by is required."),
  });

  useEffect(() => {
    setSelectedAudience({
      label: "Select Audience",
      value: "",
    });
    if (checkAudience === 1) {
      setSelected("no");
    } else {
      setSelected("yes");
    }

    let payload = {
      page: 1,
      isAll: "yes",
    };
    if (checkAudience === 0) {
      payload.filterData = {
        hasGuestAudience: "creditq",
        dataSource: dataSourceType.value,
      };
      if (dataSourceType?.value) {
        dispatch(getAudiences(payload));
      }
      console.log("Call audience@@@@creditq", payload);
    } else {
      payload.filterData = {
        hasGuestAudience: "gust",
      };
      dispatch(getAudiences(payload));
      console.log("Call audience@@@@guest", payload);
    }
  }, [dispatch, checkAudience, dataSourceType]);

  useEffect(() => {
    dispatch(fetchAllVendors());
  }, []);

  useEffect(() => {
    let campaignId = params.id;
    if (campaignId) {
      dispatch(loadCampaign(campaignId));
      dispatch(loadCampaignRecurrence(campaignId));
    }
  }, [params.id, dispatch]);

  useEffect(() => {
    let campaignId = params.id;
    if (campaignId) {
      dispatch(loadCampaignRecurrence(campaignId));
    }
  }, [params.id]);

  const dataSourceOptions = useMemo(() => {
    return [
      { value: "QUERY", label: "Query" },
      { value: "FUNCTION", label: "Function" },
    ];
  }, []);

  const platformOptions = useMemo(() => {
    if (Array.isArray(vendors)) {
      return vendors.map((vendor) => ({
        value: vendor.name,
        label: vendor.name,
        id: vendor.id
      }));
    }
    return [];
  }, [vendors]);

  useEffect(() => {
    if (campaign && campaign.data?.dataSource) {
      const selectedDataSource = dataSourceOptions.find(
        (item) => item.value === campaign.data?.dataSource
      );
      setDataSourceType({
        label: selectedDataSource.label,
        value: campaign.data?.dataSource,
      });
    }
  }, [campaign, dataSourceOptions]);

  useEffect(() => {
    const vendor = campaign?.data?.vendor;
    if (vendor?.id && vendor?.name) {
      setPlatform({
        id: vendor.id,
        label: vendor.name,
        value: vendor.name,
      });
    }
  }, [campaign?.data?.vendor?.id]);

  useEffect(() => {
    console.log("Audience reset");
    dispatch(audienceActions.resetAudience());
  }, [selectedAudience, dispatch]);

  useEffect(() => {
    if (campaign) {
      if (campaign.data.audience) {
        if (campaign.data.audience.hasGuestAudience === "creditq") {
          setCheckAudience(0);
        } else {
          setCheckAudience(1);
        }
      }
      if (campaign?.data?.campaignFunction) {
        if (campaign?.data?.campaignFunction) {
          setCheckAudience(0);
        } else {
          setCheckAudience(1);
        }
      }
    }
    console.log("campaignData@@@@@result", campaign);
  }, [campaign]);

  const dataSourceChangeHandler = (event) => {
    console.log("dataSourceChangeHandler", event);
    if (event?.value) {
      setDataSourceTypeError(null);
    }

    setDataSourceType(event);
  };

  const platFormChangeHandler = (event) => {
    if (event.value) {
      setPlatFormSelectError(null);
    }

    console.log("Eventttt : ", event);
    setPlatform(event);
  }

  const submitHandler = async () => {
    try {
      if (!dataSourceType?.value && !checkAudience) {
        console.log("Data source is missing....");
        setDataSourceTypeError("Please select Audience search by");
        return;
      }

      if (campaign?.data?.channel?.name === 'ivr' && !platform?.value) {
        setPlatFormSelectError("Please select a platform.");
        return;
      }

      console.log("selectedAudience values : ", selectedAudience.value)
      let payload = {
        audience: selectedAudience.value,
        id: campaign?.data.id,
        isRepeat: campaign?.data.isRepeat,
        dataSource: dataSourceType?.value ? dataSourceType?.value : null,
        vendor: platform
      };


      console.log("setAudience@@@@payload", payload);
      await campaignSchema
        .isValid(payload)
        .then(function (valid) {
          setIsNameValid(valid);
          if (valid) {
            dispatch(updateCampaign(payload));
            //refresh error notification
            setTimeout(() => {
              dispatch(getCampaignErrorCount());
            }, 500);
            navigate("/campaigns/edit/others/" + campaign?.data?.id);
          }
        })
        .catch((error) => {
          console.log("Eroorrrrrrrrrr - ", error);
        });
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const clickEvent = (event) => {
    if (event === "gustAudience") {
      setCheckAudience(1);
    } else {
      setCheckAudience(0);
    }
  };

  console.log("audiences@result", audiences);

  return (
    <Layout>
      <Row>
        <Col md={8}>
          <div className="pageHeader mb-6 d-flex justify-content-between align-items-center">
            <div>
              <h3 className="smallHeading mb-3">Create Campaign</h3>
              <h1>Select Audience</h1>
            </div>
            {(campaign?.data?.channel?.name === 'ivr' || campaign?.data?.channel?.name === 'ivr_marketing') && (
              <div>
                {
                  hasPermission(PERMISSIONS.IVR_EXCLUDE_CONTACTS.VIEW) && <Button variant="outline-primary" onClick={() => setShowIvrExcludeAudienceModal(true)}>Exclude Audience</Button>
                }
                {showIvrExcludeAudienceModal && <IvrExcludeAudience
                  showIvrExcludeAudienceModal={showIvrExcludeAudienceModal}
                  setShowIvrExcludeAudienceModal={setShowIvrExcludeAudienceModal}
                  campaign={campaign} />}
              </div>
            )}
          </div>
          <div>
            <Form>
              {["radio"].map((type) => (
                <div key={`inline-${type}`} className="mb-3">
                  <Form.Check
                    inline
                    label="Creditq Audience"
                    name="selectAudience"
                    type={type}
                    id="creditqAudience"
                    value="yes"
                    checked={selected === "yes"}
                    onClick={(e) => {
                      clickEvent(e.target.id);
                    }}
                  // checkAudience == defaultChecked ? :""
                  />
                  {
                    campaign?.data?.channel?.name === 'ivr' || campaign?.data?.channel?.name === 'ivr_marketing' ? <></> : <Form.Check
                      inline
                      label="Gust Audience"
                      name="selectAudience"
                      type={type}
                      id="gustAudience"
                      value="no"
                      checked={selected === "no"}
                      onClick={(e) => {
                        clickEvent(e.target.id);
                      }}
                    />
                  }
                </div>
              ))}
            </Form>
          </div>
          {!checkAudience && (
            <div>
              <Form>
                <Select
                  options={dataSourceOptions}
                  value={dataSourceType}
                  onChange={dataSourceChangeHandler}
                  placeholder="Audience search by"
                  name="dataSourceType"
                />
              </Form>
              {dataSourceTypeError && (
                <div className="errorText">{dataSourceTypeError}</div>
              )}
            </div>
          )}

          {
            (campaign?.data?.channel?.name === 'ivr' || campaign?.data?.channel?.name === 'ivr_marketing') && <>
              <br />
              <div>
                <label htmlFor="platform">Select Platform</label>
                <Form>
                  <Select
                    options={platformOptions}
                    value={platform}
                    onChange={platFormChangeHandler}
                    placeholder="Select a platform"
                    name="platformType"
                    id="platform"
                  />
                </Form>
                {platformSelectError && (
                  <div className="errorText">{platformSelectError}</div>
                )}
              </div></>
          }

          <div className="progressSteps mt-5 mb-5">
            {audiences && (
              <AudienceSelector
                audiences={audiences}
                selectedAudience={selectedAudience}
                setSelectedAudience={setSelectedAudience}
                campaign={campaign}
                checkAudience={checkAudience}
                dataSourceType={dataSourceType}
              />
            )}
            {!isAudienceValid && (
              <p className="text-danger pt-3 text-center">
                Please select or create Audience.
              </p>
            )}
          </div>
          <CampaignFooter
            nextStep="Select Others"
            buttonTitle="Set Audience"
            onNextStepHandler={submitHandler}
          />
        </Col>
        <Col md={4} className={Classes.sidebarBackground}>
          <div
            className={Classes.sidebarBackground}
            style={{ height: "100VH" }}
          >
            <ProgressBar
              campaign={campaign}
              updateCampData={updateCampData}
              campaignRecurrence={campaignRecurrence}
            />
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default SetCampaignAudience;
